// extracted by mini-css-extract-plugin
module.exports = {"ArrowRightLink":"ArrowRightLink_ArrowRightLink__WEB4I","ArrowRightLink_icon":"ArrowRightLink_ArrowRightLink_icon__JjrWY"};